import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
// Components
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Container from '../../Components/Container';
import CarouselNews from '../../Components/CarouselNews';
import LoginModal from '../../Components/LoginModal';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Slice
import {
  setUserEmail as setUserEmailAction,
  setUserName as setUserNameAction,
  setUserLastname as setUserLastnameAction,
  setUserCode as setUserCodeAction,
  setIpLogin as setIpLoginAction,
  setActiveChat,
  setLms,
} from '../../app/features/userSlice';
// Services
import { getIpUser } from '../../services/getIpUser';
import { getInfoUserMoodle } from '../../services/getInfoUserMoodle';
import { getInfoUserCanvas } from '../../services/getInfoUserCanvas';
import { getInfoUserDigitalOcean } from '../../services/getInfoUserDigitalOcean';
// Images
// IntroJs
import introJs from 'intro.js';
// Styles
import 'intro.js/introjs.css';
import './HomePage.css';
import './NewHomePage.css';
import { getInfoUserBlackboard } from '../../services/getInfoUserBlackboard';
import { handleGetFavorites } from '../../Components/FavoriteButton/utils';
import { useAuth } from '../../hooks/useAuth';
import { isCosmetology } from '../../utils/isCosmetology';
import Loading from '../../Components/Loading';
import { autenticationURL } from '../../services/Login/getInstitutionData';
import { useCookie } from '../../hooks/useCookie';

// Sources IMAGE
import GaleSourceImg from '../../Images/Sources/gale.png';
import PlosSourceImg from '../../Images/Sources/plos.png';
import EuropeSourceImg from '../../Images/Sources/europe-pubmed.png';
import DoajSourceImg from '../../Images/Sources/doaj.png';
import AccessSourceImg from '../../Images/Sources/accessScience.png';
import MobileCarousel from '../../Components/MobileCarousel';

import SectionCard from '../../Components/V2/SectionCard';
import { useRedirect } from '../../hooks/useRedirect';
import AquinoReading from '../../Images/aquino-reading.png';
import TopicCard from '../../Components/V2/TopicCards';
import HelpTooltipImg from '../../Images/HomePage/Sections/tooltip-help.png';
import HelpTooltipImgEs from '../../Images/HomePage/Sections/tooltip-help-es.png';
import PhoneHelpImg from '../../Images/HomePage/Sections/phone-help.png';
import PhoneHelpImgEs from '../../Images/HomePage/Sections/phone-help-es.png';
import YellowArrow from '../../Images/HomePage/Sections/yellow-arrow-2.png';
import PDFicon from '../../Images/HomePage/pdf-icon.png';
import NewsCarousel from '../../Components/V2/NewsCarousel';
import { getNews } from '../../services/news';
import { Link } from 'react-router-dom';
// Translate
import { useTranslation } from 'react-i18next';

const HomePage = () => {
  const { t } = useTranslation();
  // const [searchParamsTest, setSearchParam] = useSearchParams()

  // Verify Identity
  const { getCookie, removeCookie } = useCookie('is_validating_identity');
  const [searchParams] = useSearchParams();
  const isHomeWithVerifyIdentityParam = searchParams.get('verify_identity');
  const isVerifyIdentity = isHomeWithVerifyIdentityParam === 'true';
  const [news, setNews] = useState([]);

  // Hooks
  const { redirect } = useRedirect();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    isUserLoggedInAndHasLoggingSettingsActive,
    hasHasLoggingSettingsActive,
  } = useAuth();
  const canExecuteLogger = isUserLoggedInAndHasLoggingSettingsActive();
  const hasLoginSettingsActive = hasHasLoggingSettingsActive();
  // Slices
  const { activeLoginModal, ip_login, lms } = useSelector(
    (state) => state.user
  );
  const { base_news } = useSelector((state) => state.news);
  const { languageInstitution } = useSelector((state) => state.institution);
  const { topics, institutionCode, institutionLogo, assignedLogin } =
    useSelector((state) => state.institution);
  const isCosmetologyInstitution = isCosmetology(institutionCode);
  useEffect(() => {
    getIpUserInit();
    getUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);
  const getIpUserInit = () => {
    if (ip_login === '') {
      getIpUser()
        .then((data) => {
          dispatch(setIpLoginAction(data));
        })
        .catch((error) => {
          console.error('Request error:', error);
        });
    }
  };

  const handleGetNews = async (institutionCode) => {
    try {
      const news = await getNews(institutionCode);
      setNews(news);
    } catch (error) {
      console.error('Error fetching news:', error);
    }
  };
  const getUserInfo = () => {
    const currentUrl = new URL(window.location.href);

    const codeParam = searchParams.get('code');
    const userParam = searchParams.get('user');

    if (codeParam) {
      searchParams.delete('code');
      currentUrl.search = searchParams.toString();
      window.history.replaceState({}, '', currentUrl.href);
      dispatch(setUserCodeAction(codeParam));

      if (lms === 'moodle') {
        getInfoUserMoodle(codeParam, institutionCode)
          .then((data) => {
            if (data !== null) {
              data.data.email && dispatch(setUserEmailAction(data.data.email));
              if (data?.data?.email) {
                handleGetFavorites(data?.data?.email, dispatch);
              }
              data.data.firstname &&
                dispatch(setUserNameAction(data.data.firstname));
              data.data.lastname &&
                dispatch(setUserLastnameAction(data.data.lastname));
            }
            navigate('/articles');
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }

      if (lms === 'moodle 2.9') {
        getInfoUserMoodle(codeParam, `${institutionCode}_2`)
          .then((data) => {
            if (data !== null) {
              data.data.email && dispatch(setUserEmailAction(data.data.email));
              if (data?.data?.email) {
                handleGetFavorites(data?.data?.email, dispatch);
              }
              data.data.firstname &&
                dispatch(setUserNameAction(data.data.firstname));
              data.data.lastname &&
                dispatch(setUserLastnameAction(data.data.lastname));
            }
            navigate('/articles');
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }

      if (lms === 'canvas') {
        getInfoUserCanvas(codeParam, institutionCode)
          .then((data) => {
            const isValidatingIdentityCookie = getCookie();

            if (data !== null) {
              data.data.email && dispatch(setUserEmailAction(data.data.email));
              if (data?.data?.email) {
                handleGetFavorites(data?.data?.email, dispatch);
              }

              data.data.name && dispatch(setUserNameAction(data.data.name));
              data.data.lastname &&
                dispatch(setUserLastnameAction(data.data.lastname));
            }

            // Si existe la cookie y ya el home no tiene parametro verify_identity
            if (isValidatingIdentityCookie && !isVerifyIdentity) {
              removeCookie();
              navigate('/tutorials?download_certificate=true');
              return;
            }

            navigate('/articles');
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }

      if (lms === 'digitalocean') {
        getInfoUserDigitalOcean(codeParam, institutionCode)
          .then((data) => {
            if (data !== null) {
              data.data.email && dispatch(setUserEmailAction(data.data.email));
              if (data?.data?.email) {
                handleGetFavorites(data?.data?.email, dispatch);
              }
              const nameParts = data.data.name.split(' ');
              if (data.data.name) {
                dispatch(setUserNameAction(nameParts[0]));
              }
              if (nameParts.length > 1) {
                dispatch(setUserLastnameAction(nameParts.slice(1).join(' ')));
              }
            }
            navigate('/articles');
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }
      if (lms === 'blackboard') {
        getInfoUserBlackboard(codeParam, institutionCode)
          .then((data) => {
            const userData = data?.data;

            if (data !== null) {
              userData?.contact.email &&
                dispatch(setUserEmailAction(userData?.contact.email));
              handleGetFavorites(userData?.contact.email, dispatch);
            }

            if (userData?.name.given.length > 0) {
              dispatch(setUserNameAction(userData?.name?.given));
            }

            if (userData?.name.family.length > 0) {
              dispatch(setUserLastnameAction(userData?.name?.family));
            }

            navigate('/articles');
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }
    }
    if (userParam) {
      searchParams.delete('user');
      currentUrl.search = searchParams.toString();
      window.history.replaceState({}, '', currentUrl.href);
      dispatch(setUserEmailAction(userParam));
      handleGetFavorites(userParam, dispatch);
      dispatch(setUserNameAction(userParam));
      dispatch(setUserLastnameAction(userParam));
    }
  };

  // const handleGoToSection = (e) => {
  // 	if (!hasLoginSettingsActive) return;
  // 	if (!canExecuteLogger && hasLoginSettingsActive) {
  // 		preventBehavior(e);
  // 		dispatch(setActiveLoginModal(true));
  // 		return;
  // 	}

  // 	return;
  // };

  useEffect(() => {
    if (institutionCode && isCosmetologyInstitution) {
      navigate('/media');
    }

    if (
      institutionCode &&
      !isCosmetologyInstitution &&
      localStorage.introShown === undefined
    ) {
      location.pathname === '/' &&
        introJs()
          .setOption('dontShowAgain', true)
          .setOptions({
            showProgress: true,
            showBullets: false,
          })
          .start();
      localStorage.setItem('introShown', 'true');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [institutionCode, isCosmetologyInstitution, location.search]);

  const getLoginCanvas = () => {
    const hasCanvaLogin = assignedLogin?.includes('canvas');

    if (hasCanvaLogin) {
      dispatch(setLms('canvas'));
      window.location.href = autenticationURL('canvas', institutionCode);
    }
  };

  // Redirecciona al LMS (CANVAS) Para hacer login y obtener la informacion del usuario
  useEffect(() => {
    if (isVerifyIdentity) {
      getLoginCanvas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVerifyIdentity]);

  useEffect(() => {
    if (institutionCode) {
      handleGetNews(institutionCode);
    }
  }, [institutionCode]);

  return (
    <>
      {/* Si la institucion es cosmetology y el codigo de la institucion existe, se muestra un loading, esto es para evitar que el usuario vea la pagina de inicio de sesion de cosmetology, ya que no es necesario */}
      {isCosmetologyInstitution && institutionCode && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Loading height={100} width={100} />
        </div>
      )}

      {/* Si la institucion no es cosmetology y el codigo de la institucion existe, se muestra la pagina de inicio */}
      {!isCosmetologyInstitution && institutionCode && (
        <>
          <Header
            institutionCode={institutionCode}
            institutionLogo={institutionLogo}
          />
          {activeLoginModal && <LoginModal />}
          <main>
            <section className='metasearchHome'>
              <div
                className='home_header'
                data-title='Welcome to our Website! 👋'
                data-intro="We're excited to have you here. Let's get started with a quick tour of our site's key features."
                data-step='1'
              >
                <Container>
                  <div className='header_content'>
                    <div
                      className='header_title'
                      data-title='Congratulations!'
                      data-intro="You've completed the onboarding process. Enjoy your journey with us, and remember, we're always here to assist you!"
                      data-step='6'
                    >
                      {t('The easiest way to Find')}
                      <br />
                      <span className='header_title__knowledge'>
                        {t('knowledge')}
                      </span>
                    </div>
                    <div className='header_description'>
                      {t('Search for books, journals, and academic articles')}
                    </div>
                    <button
                      className='header_explore_btn'
                      onClick={() => redirect('articles')}
                    >
                      {t('Explore our Library')}
                    </button>

                    <div className='header_bottom'>
                      <div className='left'>
                        <div className='header_sources'>
                          {t('More than')} <b>150,874</b> {t('sources in just')}{' '}
                          <b>{t('one site')}</b>
                        </div>
                      </div>

                      <div className='right'>
                        <div className='header_sources_list'>
                          <div className='header_source-item gale-item'>
                            <img src={GaleSourceImg} alt='gale img' />
                          </div>
                          <div className='header_source-item plos-item'>
                            <img src={PlosSourceImg} alt='plos img' />
                          </div>
                          <div className='header_source-item pubmed-item'>
                            <img src={EuropeSourceImg} alt='europe img' />
                          </div>
                          <div className='header_source-item doaj-item'>
                            <img src={DoajSourceImg} alt='doaj img' />
                          </div>
                          <div className='header_source-item access-item'>
                            <img src={AccessSourceImg} alt='access img' />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </section>

            <section className='sections-home'>
              <Container className='pt-8 md:py-10 xl:py-16'>
                <div className='flex gap-5 justify-between items-start mb-11'>
                  <h3 className='text-2xl md:text-4xl font-semibold'>
                    {t('Your All-in-One')}
                  </h3>
                  <Link
                    to='/articles'
                    className='w-[250px] text-center px-[23px] py-[10px] rounded-[25px] border border-[#1B2831]'
                  >
                    {t('Explore all resources')}
                  </Link>
                </div>

                {/* Mobile */}
                <MobileCarousel visibleItems={1} />

                {/* Desktop */}
                <SectionCard />
              </Container>
            </section>

            <section className=' flex g-[25px]'>
              <Container className='px-[1rem]'>
                <div className='bg-[#f5f5f7] flex flex-col xl:flex-row gap-7 justify-center items-center w-full py-20 px-4 xl:px-20 rounded-3xl'>
                  <div className='section-find-hundred-header'>
                    <div className='home-title'>
                      <div>
                        {t('Find hundreds of sources searching by topics')}
                      </div>
                      <div className='aquino-img'>
                        <img
                          loading='lazy'
                          src={AquinoReading}
                          alt='Aquino Reading'
                        />
                      </div>
                    </div>
                    <div className='home-description'>
                      {t('Access specialized resources organized')}
                    </div>
                  </div>

                  <div className='topic-cards'>
                    {topics &&
                      topics?.map((topic, i) => (
                        <TopicCard
                          key={i}
                          iconSrc={topic?.path}
                          title={topic.name}
                          canExecuteLogger={canExecuteLogger}
                          hasLoginSettingsActive={hasLoginSettingsActive}
                          name={topic?.name}
                          isDark={(i + 1) % 2 === 0}
                        />
                      ))}
                  </div>
                </div>
              </Container>
            </section>

            <section className='help-section'>
              <Container className='help-section-container-width'>
                <img
                  loading='lazy'
                  src={AquinoReading}
                  alt=''
                  className='aquino-reading-help-section-img'
                />
                <div className='content'>
                  <div className='left'>
                    <img
                      loading='lazy'
                      src={
                        languageInstitution === 'en'
                          ? PhoneHelpImg
                          : PhoneHelpImgEs
                      }
                      alt=''
                    />
                  </div>
                  <div className='right'>
                    <img
                      loading='lazy'
                      src={
                        languageInstitution === 'en'
                          ? HelpTooltipImg
                          : HelpTooltipImgEs
                      }
                      alt='tooltip'
                      className='do-you-have-tooltip-img'
                    />
                    <div className='title'>
                      <b>{t('Need help?')}</b>{' '}
                      {t("We're here to help you every step of the way")}
                    </div>

                    <div className='description'>
                      <p>{t('We understand that while browsing')}</p>
                      <div className='help-arrow-container'>
                        <p>
                          {t('In any library view')}{' '}
                          <b>
                            {t('Do you have any questions or suggestions?')}
                          </b>{' '}
                          {t('This is your direct access to our support team')}
                        </p>

                        <img
                          loading='lazy'
                          src={YellowArrow}
                          alt=''
                          className='help-arrow-img'
                        />
                      </div>
                      <p>
                        <b style={{ fontWeight: '500' }}>
                          {t(
                            'Your question has a place, and so does our answer'
                          )}
                        </b>
                      </p>
                    </div>

                    <div className='help-button'>
                      <button onClick={() => dispatch(setActiveChat(true))}>
                        {t('Submit a support request')}
                      </button>
                    </div>
                  </div>
                </div>
              </Container>
            </section>

            {news && news?.length > 0 && (
              <section className='news-section-home'>
                <Container>
                  <div className='max-w-md mx-auto py-4'>
                    <NewsCarousel visibleItems={1} news={news} />
                  </div>
                </Container>
              </section>
            )}

            <section className='sections-development-policy'>
              <Container>
                <div className='home-title'>
                  {t('Learn about our Collection Development Policy')}
                </div>
                <div className='home-description policy-description'>
                  {t('In our library, every resource counts')}
                </div>
                <div className='home-description policy-description'>
                  {t("If you'd like to know how we select content")}
                </div>
                <div className='home-description policy-description'>
                  <b>{t('Download the full policy')}</b>
                </div>

                <div className='pdf-btn'>
                  <button
                    className='policy-development__button'
                    onClick={() =>
                      window.open(
                        'https://institutions-assets.s3.us-east-2.amazonaws.com/static/collection_development_policy.pdf',
                        '_blank'
                      )
                    }
                  >
                    Download in English{' '}
                    <img loading='lazy' src={PDFicon} alt='' />
                  </button>
                  <button
                    className='policy-development__button'
                    onClick={() =>
                      window.open(
                        'https://institutions-assets.s3.us-east-2.amazonaws.com/static/Politica_de_Desarrollo_de_Colecciones_Olib.pdf',
                        '_blank'
                      )
                    }
                  >
                    Descargar en Español{' '}
                    <img loading='lazy' src={PDFicon} alt='' />
                  </button>
                </div>
              </Container>
            </section>
            <section className='newsHome'>
              <Container className='newsHomeContainer'>
                <h2 className='newsHomeContainerTitle'>
                  {t('Discover all the')} <b>{t('scientific news')}</b>
                </h2>
                <p className='newsHomeContainerText'>
                  {t('Stay up to date with news and updates')}
                </p>
                <div className='carouselNewsInfoPage'>
                  <CarouselNews
                    news={base_news.slice(0, 4)}
                    canExecuteLogger={canExecuteLogger}
                    hasLoginSettingsActive={hasLoginSettingsActive}
                    language={languageInstitution}
                  />
                </div>
              </Container>
            </section>
          </main>
          <Footer />
        </>
      )}
    </>
  );
};

export default HomePage;
